import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";

import { LoginComponent } from "./login/login.component";
import { SchoolregistrationComponent } from "./schoolregistration/schoolregistration.component";
import { DashboardV2Component } from "./dashboard-v2/dashboard-v2.component";
import { AdmissionComponent } from "./admission/admission.component";
import { FeesManagementComponent } from "./feesmanage/feesmanage.component";
import { FeesManageV2Component } from "./feesmanage-v2/feesmanage-v2.component";
import { TransportComponent } from "./transport/transport.component";
import { TransportV2Component } from "./transport-v2/transport-v2.component";
import { GroupsComponent } from "./groups/groups.component";
import { GroupsV2Component } from "./groups-v2/groups-v2.component";
import { SmsMessageComponent } from "./smsmessage/smsmessage.component";
import { AcademicsComponent } from "./academics/academics.component";
import { ClassmanageComponent } from "./classmanage/classmanage.component";
import { ClassManageV2Component } from "./classmanage-v2/classmanage-v2.component";
import { ExamComponent } from "./exams/exam.component";
import { ExpensesComponent } from "./expenses/expense.component";
import { SettingsComponent } from "./settings/settings.component";
import { PagenotfoundComponent } from "./pagenotfound/pagenotfound.component";
import { SchoolSuspendedComponent } from "./schoolsuspended/schoolsuspended.component";
import { FranchiseComponent } from "./franchise/franchise.component";
import { SchoollistComponent } from "./franchise/schoollist.component";
import { FranchiseSettingsComponent } from "./franchise/settings.component";
import { AddSchoolComponent } from "./franchise/addschool.component";
import { NewSchoolRegistrationComponent } from "./new-school-registration/new-school-registration.component";
import { NewLoginWithDomainVerificationComponent } from "./new-login-with-domain-verification/new-login-with-domain-verification.component";
import { SchoolRegistrationUnderVerificationComponent } from "./school-registration-under-verification/school-registration-under-verification.component";
import { SchoolDetailsComponent } from "./school-details/school-details.component";
import {
  adminGuard, staffGuard, featureGuard, menuFeatureGuard,
  broadcastMenuGuard, profileMenuGuard, searchMenuGuard, vehicleManagementMenuGuard,
  academicCalendarMenuGuard, studentCheckInMenuGuard, feeCollectionMenuGuard, viewStaffAttendanceMenuGuard,
  leaveManagementMenuGuard
} from "./auth.guard";
// Parent portal's own guard, kept in a separate file/import from
// admin/staffGuard above — see parent-auth.guard.ts for why.
import { parentAuthGuard, parentHomeRedirectGuard, parentHostGuard, parentLoginRouteGuard } from "./parent-login/parent-auth.guard";
import { ParentLoginComponent } from "./parent-login/parent-login.component";
import { ServerDownComponent } from "./server-down/server-down.component";
import { TcGenerationComponent } from "./tc-generation/tc-generation.component";
import { CategoryWiseReportComponent } from "./category-wise-report/category-wise-report.component";
import { BroadcastComponent } from "./broadcast/broadcast.component";
import { BroadcastV2Component } from "./broadcast-v2/broadcast-v2.component";
import { TransferCertificateReportComponent } from "./transfer-certificate-report/transfer-certificate-report.component";
import { AttendanceReportComponent } from "./attendance-report/attendance-report.component";
import { NgxDaterangepickerMd } from "ngx-daterangepicker-material";
import { AcademicCalendarComponent } from "./academic-calendar/academic-calendar.component";
import { EventCategoryComponent } from "./event-category/event-category.component";
import { AcademicHolidaysComponent } from "./academic-holidays/academic-holidays.component";
import { PendingFeesReportComponent } from "./pending-fees-report/pending-fees-report.component";
import { IdCardComponent } from "./id-card/id-card.component";
import { ExpenseReportComponent } from "./expense-report/expense-report.component";
import { CheckinCheckoutReportComponent } from "./checkin-checkout-report/checkin-checkout-report.component";
import { FeesOverdueReportComponent } from "./fees-overdue-report/fees-overdue-report.component";
import { LayoutComponent } from "./layout/layout.component";
import { StaffLayoutComponent } from "./staff/layout/staff-layout.component";
import { StaffHomeComponent } from "./staff/home/staff-home.component";
import { StaffDashboardComponent } from "./staff/dashboard/staff-dashboard.component";
import { StaffClassOverviewComponent } from "./staff/class-overview/staff-class-overview.component";
import { StaffClassDiaryComponent } from "./staff/class-diary/staff-class-diary.component";
import { StaffClassAttendanceComponent } from "./staff/class-attendance/staff-class-attendance.component";
import { StaffPeriodWiseAttendanceComponent } from "./staff/period-wise-attendance/staff-period-wise-attendance.component";
import { StaffClassChatComponent } from "./staff/class-chat/staff-class-chat.component";
import { StaffClassActivityComponent } from "./staff/class-activity/staff-class-activity.component";
import { StaffClassStudentsComponent } from "./staff/class-students/staff-class-students.component";
import { StaffClassTimetableComponent } from "./staff/class-timetable/staff-class-timetable.component";
import { StaffMyTimetableComponent } from "./staff/my-timetable/staff-my-timetable.component";
import { StaffPagenotfoundComponent } from "./staff/pagenotfound/staff-pagenotfound.component";
import { StaffStudentDetailComponent } from "./staff/student-detail/staff-student-detail.component";
import { StaffProfileComponent } from "./staff/profile/staff-profile.component";
import { StaffMemberProfileComponent } from "./staff/staff-member-profile/staff-member-profile.component";
import { StaffBroadcastComponent } from "./staff/broadcast/staff-broadcast.component";
import { StaffAcademicCalendarComponent } from "./staff/academic-calendar/staff-academic-calendar.component";
import { StaffFeesComponent } from "./staff/fees/staff-fees.component";
import { StaffFeesMonthlyComponent } from "./staff/fees-monthly/staff-fees-monthly.component";
import { StaffFeesReportComponent } from "./staff/fees-report/staff-fees-report.component";
import { StaffFeesReportStudentsComponent } from "./staff/fees-report-students/staff-fees-report-students.component";
import { StaffFeesReportStudentHistoryComponent } from "./staff/fees-report-student-history/staff-fees-report-student-history.component";
import { StaffFeesReportOverdueStudentsComponent } from "./staff/fees-report-overdue-students/staff-fees-report-overdue-students.component";
import { StaffFeesReportOverdueStudentHistoryComponent } from "./staff/fees-report-overdue-student-history/staff-fees-report-overdue-student-history.component";
import { StaffTransportComponent } from "./staff/transport/staff-transport.component";
import { StaffCheckInComponent } from "./staff/checkin/staff-checkin.component";
import { StaffViewAttendanceComponent } from "./staff/view-attendance/staff-view-attendance.component";
import { StaffLeaveManagementComponent } from "./staff/leave-management/staff-leave-management.component";
import { StaffSearchComponent } from "./staff/search/staff-search.component";
import { InsightsComponent } from "./insights/insights.component";
import { AdmissionInquiryComponent } from "./admission-inquiry/admission-inquiry.component";
import { STAFF_DEFAULT_SCREEN } from "./staff/constant/staff-default-screen.config";

const routes: Routes = [
    ///// changing login to old/login
    { path: "old/login", component: LoginComponent },
    // parentLoginRouteGuard keeps the parent subdomain off this component
    // entirely — see parent-auth.guard.ts for why.
    { path: "login", component: NewLoginWithDomainVerificationComponent, canActivate: [parentLoginRouteGuard] },
    { path: "login/:sid/:token", component: LoginComponent },
    ///// changing registration to old/registration
    { path: "old/registration", component: SchoolregistrationComponent },
    { path: "registration", component: NewSchoolRegistrationComponent },
    { path: "suspended", component: SchoolSuspendedComponent },
    { path: "institute-onboard/step/1", component: SchoolDetailsComponent, canActivate: [adminGuard] },
    { path: "institute-under-verification", component: SchoolRegistrationUnderVerificationComponent, canActivate: [adminGuard] },
    // parentHomeRedirectGuard always navigates away and returns false, so
    // this component never actually renders — it only satisfies Router's
    // requirement that a matchable route resolve to a component. Uses
    // PagenotfoundComponent (side-effect-free) rather than
    // NewLoginWithDomainVerificationComponent — that component's own
    // constructor unconditionally calls verifySchoolDomainDetails(), which
    // fired even though the guard blocked activation, causing
    // parent.<domainSuffix>/ to call the school-domain-validation API and
    // get redirected to app.<domainSuffix> before the guard's own redirect
    // could win. Replaces a static redirectTo: "/login" so the bare domain
    // root resolves per-hostname (parent.<domainSuffix>/ needs to land on
    // /parent/login or /parent/dashboard, not the admin login).
    { path: "", component: PagenotfoundComponent, canActivate: [parentHomeRedirectGuard], pathMatch: "full" },
    { path: "server/down", component: ServerDownComponent },
    // Parent portal — separate guard (parentAuthGuard) from admin/staff's
    // adminGuard/staffGuard above; see parent-auth.guard.ts. All three
    // routes point at the same ParentLoginComponent, which switches
    // internally between its login form and dashboard/diary view.
    { path: "parent/login", component: ParentLoginComponent, canActivate: [parentHostGuard] },
    { path: "parent/dashboard", component: ParentLoginComponent, canActivate: [parentHostGuard, parentAuthGuard] },
    { path: "parent/diary", component: ParentLoginComponent, canActivate: [parentHostGuard, parentAuthGuard] },
    { path: "parent/attendance", component: ParentLoginComponent, canActivate: [parentHostGuard, parentAuthGuard] },
    { path: "parent/timetable", component: ParentLoginComponent, canActivate: [parentHostGuard, parentAuthGuard] },
    { path: "parent/leave-request", component: ParentLoginComponent, canActivate: [parentHostGuard, parentAuthGuard] },
    { path: "parent/fees", component: ParentLoginComponent, canActivate: [parentHostGuard, parentAuthGuard] },
    { path: "parent/document-hub", component: ParentLoginComponent, canActivate: [parentHostGuard, parentAuthGuard] },
    { path: "parent/broadcast", component: ParentLoginComponent, canActivate: [parentHostGuard, parentAuthGuard] },
    { path: "parent/chat", component: ParentLoginComponent, canActivate: [parentHostGuard, parentAuthGuard] },
    { path: "parent/notifications", component: ParentLoginComponent, canActivate: [parentHostGuard, parentAuthGuard] },
    { path: "parent/my-teacher", component: ParentLoginComponent, canActivate: [parentHostGuard, parentAuthGuard] },
    { path: "parent/activity", component: ParentLoginComponent, canActivate: [parentHostGuard, parentAuthGuard] },
    { path: "parent/feedback", component: ParentLoginComponent, canActivate: [parentHostGuard, parentAuthGuard] },
    { path: "parent/academic-calendar", component: ParentLoginComponent, canActivate: [parentHostGuard, parentAuthGuard] },
    { path: "pagenotfound", component: PagenotfoundComponent },
    {
        path: "staff",
        component: StaffLayoutComponent,
        canActivate: [staffGuard],
        children: [
            { path: "dashboard", component: StaffHomeComponent, canActivate: [menuFeatureGuard('dashboard')] },
            { path: "classes", component: StaffDashboardComponent, canActivate: [menuFeatureGuard('allClasses')] },
            { path: "class/:id", component: StaffClassOverviewComponent },
            { path: "class/:id/diary", component: StaffClassDiaryComponent, canActivate: [featureGuard('DIGITAL_DIARY')] },
            { path: "class/:id/attendance", component: StaffClassAttendanceComponent, canActivate: [featureGuard('ATTENDANCE')] },
            { path: "class/:id/period-wise-attendance", component: StaffPeriodWiseAttendanceComponent, canActivate: [featureGuard('ATTENDANCE')] },
            { path: "class/:id/chat", component: StaffClassChatComponent, canActivate: [featureGuard('STAFF_PARENT_CHAT')] },
            { path: "class/:id/activity", component: StaffClassActivityComponent, canActivate: [featureGuard('GET_ACTIVITY_TIMELINE')] },
            { path: "class/:id/students", component: StaffClassStudentsComponent },
            { path: "class/:id/timetable", component: StaffClassTimetableComponent, canActivate: [featureGuard('TIME_TABLE_MANAGEMENT')] },
            { path: "my-timetable", component: StaffMyTimetableComponent, canActivate: [menuFeatureGuard('myTimetable'), featureGuard('TIME_TABLE_MANAGEMENT')] },
            { path: "student/:id", component: StaffStudentDetailComponent },
            { path: "profile", component: StaffProfileComponent, canActivate: [menuFeatureGuard('profile'), profileMenuGuard] },
            { path: "staff-member/:id", component: StaffMemberProfileComponent },
            { path: "broadcast", component: StaffBroadcastComponent, canActivate: [menuFeatureGuard('broadcast'), broadcastMenuGuard] },
            { path: "academic-calendar", component: StaffAcademicCalendarComponent, canActivate: [menuFeatureGuard('academicCalendar'), academicCalendarMenuGuard] },
            { path: "fees", component: StaffFeesComponent, canActivate: [menuFeatureGuard('feesCollection'), feeCollectionMenuGuard] },
            { path: "fees-monthly", component: StaffFeesMonthlyComponent, canActivate: [menuFeatureGuard('feesCollection'), feeCollectionMenuGuard] },
            { path: "fees-report", component: StaffFeesReportComponent, canActivate: [menuFeatureGuard('feesReports'), feeCollectionMenuGuard] },
            { path: "fees-report/class/:classId", component: StaffFeesReportStudentsComponent, canActivate: [menuFeatureGuard('feesReports'), feeCollectionMenuGuard] },
            { path: "fees-report/class/:classId/student/:studentId", component: StaffFeesReportStudentHistoryComponent, canActivate: [menuFeatureGuard('feesReports'), feeCollectionMenuGuard] },
            { path: "fees-overdue-report/class/:classId", component: StaffFeesReportOverdueStudentsComponent, canActivate: [menuFeatureGuard('feesReports'), feeCollectionMenuGuard] },
            { path: "fees-overdue-report/class/:classId/student/:studentId", component: StaffFeesReportOverdueStudentHistoryComponent, canActivate: [menuFeatureGuard('feesReports'), feeCollectionMenuGuard] },
            { path: "transport", component: StaffTransportComponent, canActivate: [menuFeatureGuard('transport'), vehicleManagementMenuGuard] },
            { path: "checkin", component: StaffCheckInComponent, canActivate: [menuFeatureGuard('checkInCheckOut'), studentCheckInMenuGuard] },
            { path: "view-attendance", component: StaffViewAttendanceComponent, canActivate: [menuFeatureGuard('viewStaffAttendance'), viewStaffAttendanceMenuGuard] },
            { path: "leave-management", component: StaffLeaveManagementComponent, canActivate: [menuFeatureGuard('leaveManagement'), leaveManagementMenuGuard] },
            { path: "search", component: StaffSearchComponent, canActivate: [menuFeatureGuard('search'), searchMenuGuard] },
            { path: "", redirectTo: STAFF_DEFAULT_SCREEN, pathMatch: "full" },
            { path: "**", component: StaffPagenotfoundComponent },
        ]
    },
    {
        path: "",
        component: LayoutComponent,
        canActivate: [adminGuard],
        children: [
            { path: "dashboard", component: DashboardV2Component },
            { path: "insights", component: InsightsComponent },
            { path: "admission", component: AdmissionComponent },
            { path: "admission-enquiry", component: AdmissionInquiryComponent },
            { path: "groups", component: GroupsV2Component },
            { path: 'groups/:tab', component: GroupsV2Component },
            { path: "academics", component: AcademicsComponent },
            { path: "class", component: ClassmanageComponent },
            // New designs are not linked from anywhere; reachable only by typing the URL.
            { path: "class-v2", component: ClassManageV2Component },
            /*{path:'broadcast', component:BroadcastComponent},*/
            { path: "fees", component: FeesManagementComponent },
            { path: "fees-v2", component: FeesManageV2Component },
            { path: "expense", component: ExpensesComponent },
            /*{path:'inventory', component:InventoryComponent},
            {path:'hostel', component:HostelComponent},*/
            { path: "exams", component: ExamComponent },
            { path: "transport", component: TransportComponent },
            { path: "transport-v2", component: TransportV2Component },
            { path: "settings", component: SettingsComponent },
            { path: "report/category-wise", component: CategoryWiseReportComponent },
            { path: "report/transfer-certificate", component: TransferCertificateReportComponent },
            { path: "report/attendance-report", component: AttendanceReportComponent },
            { path: "report/pending-fees", component: PendingFeesReportComponent },
            { path: "tc", component: TcGenerationComponent },
            /*{path:'report', component:ReportComponent},*/
            { path: "message", component: SmsMessageComponent },
            { path: "franchise/dashboard", component: FranchiseComponent },
            { path: "franchise/schoollist", component: SchoollistComponent },
            { path: "franchise/settings", component: FranchiseSettingsComponent },
            { path: "franchise/addschool", component: AddSchoolComponent },
            { path: "id-card", component: IdCardComponent },
            { path: "id-card/:tab", component: IdCardComponent },
            { path: "report/expense-report", component: ExpenseReportComponent },
            { path: "report/checkin-checkout-report", component: CheckinCheckoutReportComponent },
            { path: "report/fees-overdue-report", component: FeesOverdueReportComponent },
            {
                path: "broadcast",
                component: BroadcastV2Component, pathMatch: "full"
            },
            {
                path: "academic/calendar",
                component: AcademicCalendarComponent, pathMatch: "full"
            },
            {
                path: "academic/events",
                component: EventCategoryComponent, pathMatch: "full"
            },
            {
                path: "academic/holidays",
                component: AcademicHolidaysComponent, pathMatch: "full"
            },
            // Redirect (rather than render PagenotfoundComponent directly as a
            // child here) so the 404 page loads standalone, without LayoutComponent's
            // sidebar/header wrapping around it.
            { path: "**", redirectTo: "/pagenotfound" },
        ]
    },
];

@NgModule({
    imports: [RouterModule.forRoot(routes, {}),NgxDaterangepickerMd.forRoot()],
    exports: [RouterModule],
})
export class AppRoutingModule { }